import { useCallback, useEffect, useRef, useState } from 'react';

import { useOutsideClick } from 'utils/hooks/use-outside-click';

export const useLauncherPopover = () => {
    const [opened, setOpened] = useState(false);
    const [customizeOpen, setCustomizeOpen] = useState(false);
    const rootRef = useRef(null);

    const close = useCallback(() => {
        setOpened(false);
        setCustomizeOpen(false);
    }, []);

    const toggleOpen = useCallback(() => {
        setOpened(value => !value);
        setCustomizeOpen(false);
    }, []);

    const toggleCustomize = useCallback(() => {
        setCustomizeOpen(value => !value);
    }, []);

    useEffect(() => {
        if (!opened) {
            setCustomizeOpen(false);
        }
    }, [opened]);

    useEffect(() => {
        if (!opened) {
            return undefined;
        }

        const handleKey = event => {
            if (event.key === 'Escape') {
                close();
            }
        };

        document.addEventListener('keydown', handleKey);

        return () => document.removeEventListener('keydown', handleKey);
    }, [opened, close]);

    useOutsideClick({ ref: rootRef, callback: close, isEnabled: opened });

    return {
        opened,
        customizeOpen,
        rootRef,
        close,
        toggleOpen,
        toggleCustomize
    };
};
